module.exports = {
  baseUrl: 'https://elht.nmgrmtzx.top/api/',
  projectName: '二连浩特市融媒体中心智能管理系统'
}
